import { useMemo, useState } from "react";
import { Search, Star } from "lucide-react";
import { CATEGORY_LABELS } from "@/lib/playStyles";

const CATS = [["all", "All"], ["offense", "Offense"], ["defense", "Defense"], ["special", "Special Teams"]];

export function usePlayFilters(plays) {
  const [q, setQ] = useState("");
  const [cat, setCat] = useState("all");
  const [formation, setFormation] = useState("");
  const [tag, setTag] = useState("");
  const [fav, setFav] = useState(false);
  const formations = useMemo(() => [...new Set(plays.map((p) => p.formation).filter(Boolean))].sort(), [plays]);
  const tags = useMemo(() => [...new Set(plays.flatMap((p) => p.tags))].sort(), [plays]);
  const filtered = plays.filter((p) => {
    const text = `${p.name} ${p.formation} ${p.tags.join(" ")} ${p.description}`.toLowerCase();
    return (!q || text.includes(q.toLowerCase())) && (cat === "all" || p.category === cat) && (!formation || p.formation === formation) && (!tag || p.tags.includes(tag)) && (!fav || p.favorite);
  });
  return { q, setQ, cat, setCat, formation, setFormation, tag, setTag, fav, setFav, formations, tags, filtered };
}

export function PlayFilters({ f, showFav = true }) {
  return (
    <div className="space-y-3 mb-6" data-testid="playbook-filters">
      <div className="flex flex-wrap gap-2">
        <div className="relative flex-1 min-w-[200px]">
          <Search size={18} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-500" />
          <input className="input pl-10" placeholder="Search plays, tags, formations" value={f.q} onChange={(e) => f.setQ(e.target.value)} data-testid="input-search-playbook" />
        </div>
        {f.formations.length > 0 && (
          <select className="input w-auto" value={f.formation} onChange={(e) => f.setFormation(e.target.value)} aria-label="Formation" data-testid="filter-formation">
            <option value="">All formations</option>
            {f.formations.map((x) => <option key={x} value={x}>{x}</option>)}
          </select>
        )}
        {showFav && (
          <button className={`btn ${f.fav ? "btn-active" : "btn-ghost"}`} onClick={() => f.setFav(!f.fav)} aria-pressed={f.fav} data-testid="filter-favorites"><Star size={18} fill={f.fav ? "currentColor" : "none"} />Favorites</button>
        )}
      </div>
      <div className="flex flex-wrap gap-2" role="tablist" data-testid="filter-play-type">
        {CATS.map(([v, l]) => <button key={v} role="tab" aria-selected={f.cat === v} className={`chip ${f.cat === v ? "chip-on" : ""}`} onClick={() => f.setCat(v)} data-testid={`filter-cat-${v}`}>{l}</button>)}
        {f.tags.map((t) => <button key={t} className={`chip ${f.tag === t ? "chip-on" : ""}`} onClick={() => f.setTag(f.tag === t ? "" : t)} data-testid={`filter-tag-${t}`}>#{t}</button>)}
      </div>
    </div>
  );
}

export const catLabel = (c) => CATEGORY_LABELS[c] || c;
